import { Picker, Switch } from 'antd-mobile';

import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './OrderDetail.less';

export default class OrderDetail extends OfficialPage {
  state = {
    orderInfo: {},
    orderStatus: [
      {
        '0': '待付款',
        '1': '待发货',
        '2': '待收货',
        '3': '待评价',
        '4': '退款审核中',
        '5': '退款中',
        '6': '已完成',
        '7': '已关闭'
      },
      {
        '0': '待付款',
        '1': '待确认',
        '2': '待消费',
        '3': '待评价',
        '4': '退款审核中',
        '5': '退款中',
        '6': '已完成',
        '7': '已关闭'
      },
      {
        '0': '待付款',
        '1': '待接单',
        '2': '待送餐',
        '3': '待评价',
        '4': '退款审核中',
        '5': '退款中',
        '6': '已完成',
        '7': '已关闭'
      },
      {
        '0': '待付款',
        '1': '待商家确认',
        '2': '商家已确认',
        '3': '已完成',
        '4': '退款审核中',
        '5': '退款中',
        '6': '已完成',
        '7': '已关闭'
      }
    ],
    addressList: [],
    selectAddressId: '',
    addressDialogHidden: true,
    goodsAdditionalInfo: {},
    hasAdditionalInfo: false,
    customFields: [],
    isFromBack: false,
    orderId: '',
    isFromTemplateMsg: false,
    discountList: [],
    toStoreInfo: {},
    originalPrice: '',
    openBalance: true, //开启储值金功能
    currentBalance: '', // 当前储值金
    useBalance: '',
    freghtSwitch: '',
    freightAdress: {},
    delivery: '',
    express_fee: '',
    discount_cut_price: ''
  }

  constructor(props) {
    super(props);
    document.title = '订单详情';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.setData({
      orderId: options.detail,
      isFromTemplateMsg: options.from === 'template_msg' ? true : false,
      franchiseeId: options.franchisee || ''
    })
    this.dataInitial()
  }

  dataInitial = () => {
    this.getOrderDetail(this.data.orderId)
    this.getFreigtAdress()
    this.initialAddressId()
  }

  componentDidMount() {
    if (this.data.isFromBack) {
      if (!!this.data.orderInfo.order_id) {
        this.getOrderDetail(this.data.orderInfo.order_id, 1)
      }
    } else {
      this.setData({
        isFromBack: true
      })
    }
  }

  getOrderDetail = (orderId, isFromAddrSelect) => {
    var that = this
    app.getOrderDetail({
      data: {
        order_id: orderId,
        sub_shop_app_id: this.data.franchiseeId
      },
      success: function (res) {
        var form_data = res.data[0].form_data,
          hasAdditionalInfo = that.data.hasAdditionalInfo,
          address_id = ''
        form_data.totalPay = form_data.total_price
        if (!isFromAddrSelect) {
          for (var i = 0; i < form_data.goods_info.length; i++) {
            var deliveryId = form_data.goods_info[i].delivery_id
            if (deliveryId && deliveryId != '0') {
              that.getGoodsCustomField(i, deliveryId)
              hasAdditionalInfo = true
            }
          }
        }
        if (form_data.address_info && that.data.freghtSwitch) {
          address_id = form_data.address_info.address_id
          that.setData({
            selectAddressId: address_id
          })
        }
        if (form_data.tostore_data && form_data.tostore_data.appointed_time)
          form_data.tostore_data.format_appointed_time = form_data.tostore_data.appointed_time.substr(
            11,
            5
          )
        that.setData({
          orderInfo: form_data,
          discountList: form_data.can_use_benefit.data,
          index: form_data.can_use_benefit.selected_index,
          hasAdditionalInfo: hasAdditionalInfo,
          toStoreInfo: form_data.tostore_data,
          discount_cut_price: form_data.discount_cut_price,
          currentBalance: Number(res.data[0]['balance']),
          useBalance: Number(form_data['use_balance']),
          express_fee: res.data[0]['express_fee']
        })
        if (that.data.franchiseeId) {
          that.setData({
            openBalance: false
          })
        } else {
          if (
            that.data.orderInfo.status == 0 &&
            that.data.currentBalance < that.data.useBalance
          ) {
            app.showToast({
              title: '储值金不足，请及时充值',
              success: function () {
                that.isUseBalance()
              }
            })
          }
        }
      }
    })
  }
  orderDelete = e => {
    var orderId = this.data.orderId,
      that = this,
      franchiseeId = this.data.franchiseeId
    app.showModal({
      content: '订单删除后不可找回，确认删除？',
      showCancel: true,
      cancelText: '取消',
      confirmText: '确定',
      confirm: function () {
        app.sendRequest({
          url: '/index.php?r=AppShop/HideOrder',
          data: {
            order_id: orderId,
            sub_shop_app_id: franchiseeId
          },
          success: function (res) {
            app.turnBack()
          }
        })
      }
    })
  }
  getGoodsCustomField = (goodsIndex, deliveryId) => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=pc/AppShop/GetDelivery',
      data: {
        delivery_id: deliveryId
      },
      success: function (res) {
        var deliveryInfo = res.data.delivery_info,
          goodsId = that.data.orderInfo.goods_info[goodsIndex].goods_id,
          data = {},
          fields = []
        data['goodsAdditionalInfo.' + goodsId + ''] = deliveryInfo
        for (var i = 0; i < deliveryInfo.length; i++) {
          var info = {}
          info.type = deliveryInfo[i].type
          info.title = deliveryInfo[i].name
          fields.push(info)
        }
        data['customFields[' + goodsIndex + ']'] = fields
        that.setData(data)
      }
    })
  }
  customFieldInput = e => {
    var dataset = e.currentTarget.dataset,
      goodsIndex = dataset.goodsIndex,
      fieldIndex = dataset.fieldIndex,
      value = e.target.value,
      data = {}
    data['customFields[' + goodsIndex + '][' + fieldIndex + '].value'] = value
    this.setData(data)
  }
  uploadCustomFieldImage = e => {
    var that = this,
      dataset = e.currentTarget.dataset,
      goodsIndex = dataset.goodsIndex,
      fieldIndex = dataset.fieldIndex,
      data = {}
    app.chooseImage(function (paths) {
      data['customFields[' + goodsIndex + '][' + fieldIndex + '].value'] = paths
      that.setData(data)
    }, 9)
  }
  deleteCustomFieldImage = e => {
    var dataset = e.currentTarget.dataset,
      goodsIndex = dataset.goodsIndex,
      fieldIndex = dataset.fieldIndex,
      imageArray = this.data.customFields[goodsIndex][fieldIndex].value,
      imageIndex = dataset.imageIndex,
      data = {}
    imageArray.splice(imageIndex, 1)
    data[
      'customFields[' + goodsIndex + '][' + fieldIndex + '].value'
    ] = imageArray
    this.setData(data)
  }
  sendDeliveryInfo = () => {
    var additional_info = {},
      goodsInfo = this.data.orderInfo.goods_info
    for (var i = 0; i < goodsInfo.length; i++) {
      additional_info[goodsInfo[i].goods_id] = this.data.customFields[i]
    }
    app.sendRequest({
      url: '/index.php?r=AppShop/SetAdditional',
      method: 'POST',
      data: {
        order_id: this.data.orderInfo.order_id,
        additional_info: additional_info
      },
      success: function (res) { }
    })
  }
  cancelOrder = e => {
    var orderId = this.data.orderInfo.order_id,
      that = this
    app.showModal({
      content: '是否取消订单？',
      showCancel: true,
      confirmText: '是',
      cancelText: '否',
      confirm: function () {
        app.sendRequest({
          url: '/index.php?r=AppShop/cancelOrder',
          data: {
            order_id: orderId,
            sub_shop_app_id: that.data.franchiseeId
          },
          success: function (res) {
            var data = {}
            data['orderInfo.status'] = 7
            that.setData(data)
          }
        })
      }
    })
  }
  payOrder = e => {
    var address_info = this.data.orderInfo.address_info,
      that = this,
      orderId
    if (!address_info && this.data.orderInfo.goods_type != 3) {
      app.showModal({
        content: '请选择邮寄地址'
      })
      return
    }
    if (this.data.hasAdditionalInfo) {
      this.sendDeliveryInfo()
    }
    orderId = this.data.orderInfo.order_id
    if (this.data.orderInfo.totalPay == 0) {
      app.sendRequest({
        url: '/index.php?r=AppShop/paygoods',
        data: {
          order_id: orderId,
          total_price: 0
        },
        success: function (res) {
          app.showToast({
            title: '支付成功',
            success: function () {
              that.getOrderDetail(that.data.orderInfo.order_id)
            }
          })
        }
      })
      return
    }
    // app.sendRequest({
    //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
    //   data: {
    //     order_id: orderId
    //   },
    //   success: function (res) {
    //     var param = res.data,
    //       orderId = that.data.orderInfo.order_id
    //     param.orderId = orderId
    //     param.goodsType = that.data.orderInfo.goods_type
    //     param.success = function () {
    //       setTimeout(function () {
    //         that.getOrderDetail(orderId)
    //       }, 1500)
    //     }
    //     app.wxPay(param)
    //   }
    // })

    // TODO:支付成功回调要考虑一下怎么处理
    app.goPay({
      orderId: that.data.orderInfo.order_id
    });
  }
  applyDrawback = () => {
    var orderId = this.data.orderInfo.order_id,
      that = this
    app.showModal({
      content: '确定要申请退款？',
      showCancel: true,
      confirmText: '确定',
      cancelText: '取消',
      confirm: function () {
        app.sendRequest({
          url: '/index.php?r=AppShop/applyRefund',
          data: {
            order_id: orderId,
            sub_shop_app_id: that.data.franchiseeId
          },
          success: function (res) {
            var data = {}
            data['orderInfo.status'] = 4
            that.setData(data)
          }
        })
      }
    })
  }
  receiveDrawback = () => {
    var orderId = this.data.orderInfo.order_id,
      that = this
    app.showModal({
      content: '确定已收到退款？',
      showCancel: true,
      confirmText: '确定',
      cancelText: '取消',
      confirm: function () {
        app.sendRequest({
          url: '/index.php?r=AppShop/comfirmRefund',
          data: {
            order_id: orderId,
            sub_shop_app_id: that.data.franchiseeId
          },
          success: function (res) {
            var data = {}
            data['orderInfo.status'] = 7
            that.setData(data)
          }
        })
      }
    })
  }
  checkLogistics = () => {
    var orderId = this.data.orderInfo.order_id
    app.turnToPage(
      '/eCommerce/pages/logisticsPage/logisticsPage?detail=' + orderId
    )
  }
  sureReceipt = () => {
    var orderId = this.data.orderInfo.order_id,
      that = this
    app.showModal({
      content: '确定已收到货物？',
      showCancel: true,
      confirmText: '确定',
      cancelText: '取消',
      confirm: function () {
        app.sendRequest({
          url: '/index.php?r=AppShop/comfirmOrder',
          data: {
            order_id: orderId,
            sub_shop_app_id: that.data.franchiseeId
          },
          success: function (res) {
            var data = {}
            data['orderInfo.status'] = 3
            that.setData(data)
          }
        })
      }
    })
  }
  makeComment = () => {
    let franchiseeId = this.data.franchiseeId,
      pagePath =
        '/eCommerce/pages/makeComment/makeComment?detail=' +
        this.data.orderInfo.order_id +
        (franchiseeId ? '&franchisee=' + franchiseeId : '')
    app.turnToPage(pagePath)
  }
  addAddress = () => {
    let orderId = this.data.orderInfo.order_id
    app.turnToPage('/eCommerce/pages/addAddress/addAddress?oid=' + orderId)
  }
  selectAddress = e => {
    let index = e.currentTarget.dataset.index,
      orderId = this.data.orderInfo.order_id,
      newAddress = this.data.addressList[index],
      that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/setAddress',
      data: {
        order_id: orderId,
        address_id: newAddress.id,
        sub_shop_app_id: that.data.franchiseeId,
        is_self_delivery: delivery
      },
      success: function (res) {
        that.setData({
          'orderInfo.address_info': newAddress.address_info
        })
        that.hideAddressList()
        that.changeFreightWay()
      }
    })
  }
  editAddress = e => {
    var index = e.currentTarget.dataset.index,
      addressId = this.data.addressList[index].id,
      orderId = this.data.orderInfo.order_id
    app.turnToPage(
      '/eCommerce/pages/addAddress/addAddress?id=' +
      addressId +
      '&oid=' +
      orderId
    )
  }
  showAddressList = () => {
    var addressId = this.data.selectAddressId,
      orderId = this.data.orderInfo.order_id,
      franchiseeId = this.data.franchiseeId
    app.turnToPage(
      '/eCommerce/pages/myAddress/myAddress?id=' +
      addressId +
      '&oid=' +
      orderId +
      '&sub_shop_id=' +
      franchiseeId,
      true
    )
  }
  showAddAddress = () => {
    var orderId = this.data.orderInfo.order_id
    var _this = this
    app.chooseAddress({
      success: function (res) {
        app.sendRequest({
          method: 'post',
          url: '/index.php?r=AppShop/AddWxAddress',
          data: {
            detailInfo: res.detailInfo || '',
            cityName: res.cityName || '',
            provinceName: res.provinceName || '',
            UserName: res.userName || '',
            telNumber: res.telNumber || '',
            district: res.district || '',
            countyName: res.countyName || '',
            order_id: orderId
          },
          success: function () {
            _this.dataInitial()
          }
        })
      }
    })
  }
  hideAddressList = () => {
    this.setData({
      addressDialogHidden: true
    })
  }
  deleteAddress = e => {
    var index = e.currentTarget.dataset.index,
      id = this.data.addressList[index].id,
      that = this
    app.showModal({
      content: '确定要删除地址？',
      showCancel: true,
      confirmText: '确定',
      cancelText: '取消',
      confirm: function () {
        app.sendRequest({
          url: '/index.php?r=AppShop/delAddress',
          data: {
            address_id: id
          },
          success: function (res) {
            var list = that.data.addressList,
              data = {}
            list.splice(index, 1)
            data.addressList = list
            if (id == that.data.orderInfo.address_info.id) {
              data['orderInfo.address_info'] = null
            }
            that.setData(data)
          }
        })
      }
    })
  }
  previewImage = e => {
    app.previewImage({
      current: e.currentTarget.dataset.src
    })
  }
  goToHomepage = () => {
    var router = app.getHomepageRouter()
    app.turnToPage('/pages/' + router + '/' + router, true)
  }
  changeDiscount = e => {
    var _this = this
    var index = _this.data.orderInfo.can_use_benefit.selected_index
    var value = parseInt(e.target.value)
    this.setData({
      index: value
    })
    var discount_type =
      _this.data.orderInfo.can_use_benefit.data[value].discount_type,
      coupon_id = _this.data.orderInfo.can_use_benefit.data[value].coupon_id
    app.sendRequest({
      url: '/index.php?r=AppShop/ChangeOrder',
      data: {
        app_id: app.getAppId(),
        order_id: _this.data.orderInfo.order_id,
        discount_type: discount_type,
        coupon_id: coupon_id,
        sub_shop_app_id: _this.data.franchiseeId
      },
      success: function (res) {
        _this.getOrderDetail(res.data[0].form_data.order_id)
      }
    })
  }
  verificationCode = () => {
    app.turnToPage(
      '/eCommerce/pages/verificationCodePage/verificationCodePage?detail=' +
      this.data.orderInfo.order_id +
      '&sub_shop_app_id=' +
      this.data.franchiseeId
    )
  }
  customerConfirm = () => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/CompleteTostoreOrder',
      data: {
        order_id: this.data.orderInfo.order_id
      },
      success: function () {
        var data = {}
        data['orderInfo.status'] = 6
        that.setData(data)
      }
    })
  }
  isUseBalance = e => {
    var _this = this
    var isBalance = ''
    if (e) {
      isBalance = Number(e.target.value)
    } else {
      isBalance = 0
    }
    app.sendRequest({
      url: '/index.php?r=AppShop/ChangeOrder',
      data: {
        app_id: app.getAppId(),
        order_id: _this.data.orderInfo.order_id,
        sub_shop_app_id: _this.data.franchiseeId,
        is_balance: isBalance
      },
      success: function (res) {
        _this.getOrderDetail(res.data[0].form_data.order_id)
      }
    })
  }
  freghtRadioChange = e => {
    var data = '',
      _this = this,
      orderId = this.data.orderInfo.order_id,
      delivery = ''
    if (e.target.value == 2) {
      data = true
      delivery = 1
    } else {
      data = false
      delivery = 0
    }
    app.sendRequest({
      url: '/index.php?r=AppShop/setAddress',
      data: {
        is_self_delivery: delivery,
        order_id: orderId,
        address_id: _this.data.selectAddressId,
        sub_shop_app_id: _this.data.franchiseeId
      },
      success: function (res) {
        _this.changeFreightWay()
      }
    })
    this.setData({
      freghtSwitch: data,
      delivery: delivery
    })
  }
  getFreigtAdress = () => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/getAppShopLocationInfo',
      data: {
        app_id: app.getAppId()
      },
      success: function (res) {
        that.setData({
          freightAdress: res.data
        })
      }
    })
  }
  freightGoMap = () => {
    var _this = this,
      infor =
        _this.data.freightAdress.region_string +
        _this.data.freightAdress.shop_location
    infor = infor.replace(/\s+/g, '')
    app.sendRequest({
      url: '/index.php?r=Map/GetLatAndLngByAreaInfo',
      data: {
        location_info: infor
      },
      success: function (res) {
        if (res.result) {
          Taro.openLocation({
            latitude: res.result.location.lat,
            longitude: res.result.location.lng
          })
        }
      }
    })
  }
  initialAddressId = () => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/addressList',
      data: {
        app_id: app.getAppId()
      },
      success: function (res) {
        if (res.data.length) {
          that.setData({
            selectAddressId: res.data[0].id
          })
        }
      }
    })
  }
  changeFreightWay = () => {
    var _this = this
    var isBalance = Number(e.target.value)
    app.sendRequest({
      url: '/index.php?r=AppShop/ChangeOrder',
      data: {
        app_id: app.getAppId(),
        order_id: _this.data.orderInfo.order_id,
        sub_shop_app_id: _this.data.franchiseeId
      },
      success: function (res) {
        _this.getOrderDetail(res.data[0].form_data.order_id)
      }
    })
  }
  freightPlayPhone = () => {
    var that = this
    app.makePhoneCall(that.data.freightAdress.shop_contact)
  }

  render() {
    const {
      showGetUserInfo,
      isFromTemplateMsg,
      orderStatus,
      orderInfo,
      freightAdress,
      freghtSwitch,
      toStoreInfo,
      customFields,
      goodsAdditionalInfo,
      express_fee,
      discountList,
      discount_cut_price,
      openBalance,
      useBalance,
      currentBalance
    } = this.state
    
    return (
      <div className="official-page order-detail">
        <TopNav title="订单详情"/>
        <div className="orderDetail-wrap page" id="orderDetail">
          {isFromTemplateMsg && (
            <div
              className="orderDetail-section orderDetail-goto-homepage"
              onClick={this.goToHomepage}
              style={convertLineStyleData('margin-bottom:0;')}
            >
              <div className="ico-moon icon-rightarrow"></div>返回首页
            </div>
          )}
          <div
            className="orderDetail-section"
            style={convertLineStyleData('color:#fff;background-color:#535961;')}
          >
            <div style={convertLineStyleData('margin-bottom:4px;')}>
              {'订单状态：' +
                orderInfo.goods_type
                && orderInfo.status
                && orderStatus[orderInfo.goods_type][orderInfo.status]}
            </div>
            <div>{'订单号：' + orderInfo.order_id}</div>
          </div>
          {freightAdress.is_self_delivery != 0 && orderInfo.goods_type == 0 && (
            <div className="orderDetail-section">
              <RadioGroup
                className="freght-radio"
                onChange={this.freghtRadioChange}
              >
                <label className="radio">
                  <Radio value="1" checked="checked"></Radio>快递
                </label>
                <label className="radio">
                  <Radio value="2"></Radio>上门自提
                </label>
              </RadioGroup>
            </div>
          )}
          {(orderInfo.goods_type == 0 ||
            orderInfo.goods_type == 1 ||
            orderInfo.goods_type == 2) && (
              <div
                className="orderDetail-section orderDetail-address-detail right-arrow-bar"
                data-id={
                  orderInfo.address_info ? orderInfo.address_info.address_id : ''
                }
                hidden={freghtSwitch}
              >
                {orderInfo.address_info ? (
                  <React.Fragment>
                    <div onClick={this.showAddressList}>
                      <div>
                        {orderInfo.address_info.name +
                          ' ' +
                          orderInfo.address_info.contact}
                      </div>
                      <div style={convertLineStyleData('color:#aaa;')}>
                        {orderInfo.address_info.province.text +
                          orderInfo.address_info.city.text +
                          orderInfo.address_info.district.text +
                          orderInfo.address_info.detailAddress}
                      </div>
                    </div>
                    {orderInfo.status < 1 && (
                      <div className="orderDetail-address-ops">
                        <span onClick={this.showAddressList}>更换地址</span>
                        {/*  <text bindtap="showAddAddress">添加地址</text>  */}
                      </div>
                    )}
                  </React.Fragment>
                ) : (
                    <React.Fragment>
                      <div className="ico-moon icon-rightarrow"></div>
                      <div onClick={this.goToMyAddress}>添加地址</div>
                    </React.Fragment>
                  )}
              </div>
            )}
          <div className="orderDetail-section" hidden={!freghtSwitch}>
            <div onClick={this.freightGoMap} className="locationName">
              <label className="ico-moon icon-location freightAdress-ico"></label>
              {freightAdress.region_string + ' ' + freightAdress.shop_location}
            </div>
            <div
              className="freightAdress-phone"
              onClick={this.freightPlayPhone}
            >
              <label className="ico-moon icon-phone freightAdress-ico"></label>
              {freightAdress.shop_contact}
            </div>
            <div className="freightAdress-tip">
              亲，勾选上门店自提,需要自己去门店取货哦！
            </div>
          </div>
          {orderInfo.goods_type == 3 && (
            <React.Fragment>
              <div className="orderDetail-section">
                <div className="tostore-queue-section">
                  <span>{'取餐号: ' + toStoreInfo.formatted_queue_num}</span>
                  <span className="pull-right">
                    {'取餐时间 ' + toStoreInfo.format_appointed_time}
                  </span>
                </div>
                <div className="orderDetail-item-row">
                  位置信息:<span>{orderInfo.location_name}</span>
                </div>
                <div className="orderDetail-item-row">
                  就餐方式:
                  {toStoreInfo.tostore_order_type == 1 ? (
                    <span>点餐</span>
                  ) : (
                      <span>
                        {'预约 ' + toStoreInfo.tostore_appointment_time}
                      </span>
                    )}
                </div>
                <div className="orderDetail-item-row">
                  手机号码:<span>{toStoreInfo.tostore_buyer_phone}</span>
                </div>
                <div className="orderDetail-item-row">
                  备注信息:<span>{toStoreInfo.tostore_remark || '无'}</span>
                </div>
              </div>
            </React.Fragment>
          )}
          <div className="orderDetail-section">
            <div className="orderDetail-order-list">
              {orderInfo.goods_info && orderInfo.goods_info.map((goods, goodsIndex) => {
                return (
                  <React.Fragment key={goodsIndex}>
                    <div className="dialog-block-item">
                      <img
                        className="list-goods-cover"
                        src={goods.cover}
                      />
                      <div className="list-goods-content">
                        <div>{goods.goods_name}</div>
                        {goods.model_value && (
                          <div className="list-goods-model">
                            {goods.model_value}
                          </div>
                        )}
                      </div>
                      <div className="list-goods-right">
                        <div>{'¥' + goods.price}</div>
                        <div>{'× ' + goods.num}</div>
                      </div>
                    </div>
                    {goodsAdditionalInfo[goods.goods_id] && (
                      <div className="dialog-block-item">
                        {goodsAdditionalInfo[goods.goods_id].map(
                          (field, fieldIndex) => {
                            return (
                              <div className="customField-container" key={fieldIndex}>
                                {orderInfo.additional_info &&
                                  orderInfo.additional_info[goods.goods_id] ? (
                                    <React.Fragment>
                                      {field.type === 'text' ||
                                        field.type === 'mul-text' ? (
                                          <React.Fragment>
                                            <div>
                                              {field.name +
                                                ':' +
                                                orderInfo.additional_info[
                                                  goods.goods_id
                                                ][fieldIndex].value}
                                            </div>
                                          </React.Fragment>
                                        ) : (
                                          field.type === 'picture' && (
                                            <React.Fragment>
                                              {orderInfo.additional_info[
                                                goods.goods_id
                                              ][fieldIndex].value.map(
                                                (imgUrl, index) => {
                                                  return (
                                                    <div
                                                      className="custom-field-image"
                                                      key
                                                    >
                                                      <img
                                                        src={imgUrl}
                                                        mode="aspectFit"
                                                        onClick={this.previewImage}
                                                        data-src={imgUrl}
                                                      />
                                                    </div>
                                                  )
                                                }
                                              )}
                                            </React.Fragment>
                                          )
                                        )}
                                    </React.Fragment>
                                  ) : (
                                    <React.Fragment>
                                      {field.type === 'text' ? (
                                        <React.Fragment>
                                          <input
                                            data-name={field.name}
                                            data-goods-index={goodsIndex}
                                            data-field-index={fieldIndex}
                                            placeholder={field.name}
                                            onInput={this.customFieldInput}
                                          />
                                        </React.Fragment>
                                      ) : field.type === 'mul-text' ? (
                                        <React.Fragment>
                                          <textarea
                                            data-name={field.name}
                                            data-goods-index={goodsIndex}
                                            data-field-index={fieldIndex}
                                            placeholder={field.name}
                                            onInput={this.customFieldInput}
                                          ></textarea>
                                        </React.Fragment>
                                      ) : (
                                            field.type === 'picture' && (
                                              <React.Fragment>
                                                {customFields[goodsIndex][
                                                  fieldIndex
                                                ].value.map(
                                                  (fieldImg, imageIndex) => {
                                                    return (
                                                      <div
                                                        className="custom-field-image"
                                                        key
                                                      >
                                                        <img
                                                          src={fieldImg}
                                                          mode="aspectFit"
                                                          onClick={this.previewImage}
                                                          data-src={fieldImg}
                                                        />
                                                        <label
                                                          className="delete-img"
                                                          onClick={
                                                            this
                                                              .deleteCustomFieldImage
                                                          }
                                                          data-goods-index={
                                                            goodsIndex
                                                          }
                                                          data-field-index={
                                                            fieldIndex
                                                          }
                                                          data-image-index={
                                                            imageIndex
                                                          }
                                                        >
                                                          ×
                                                  </label>
                                                      </div>
                                                    )
                                                  }
                                                )}
                                                <div
                                                  className="upload-field-image"
                                                  onClick={
                                                    this.uploadCustomFieldImage
                                                  }
                                                  data-name={field.name}
                                                  data-goods-index={goodsIndex}
                                                  data-field-index={fieldIndex}
                                                >
                                                  {field.name}
                                                </div>
                                              </React.Fragment>
                                            )
                                          )}
                                    </React.Fragment>
                                  )}
                              </div>
                            )
                          }
                        )}
                      </div>
                    )}
                  </React.Fragment>
                )
              })}
            </div>
            <div className="dialog-block-item">
              <div className="orderDetail-item-row">
                商品总额：
                <span className="pull-right">
                  {'¥' + orderInfo.original_price}
                </span>
              </div>
              <div
                className="orderDetail-item-row"
                hidden={orderInfo.goods_type == 3}
              >
                物流费用：
                {express_fee && express_fee != 0 && (
                  <span className="pull-right">{'¥' + express_fee}</span>
                )}
                {(!express_fee || express_fee == 0) && (
                  <span className="pull-right">包邮</span>
                )}
              </div>
              <div
                className="orderDetail-item-row"
                hidden={orderInfo.selected_benefit && orderInfo.selected_benefit.discount_type == null}
              >
                <Picker
                  disabled={orderInfo.status == 0 ? false : true}
                  onChange={this.changeDiscount}
                  rangeKey="title"
                  value={index}
                  range={discountList}
                >
                  <div className="picker">
                    店铺优惠：
                    <span style={convertLineStyleData('float:right;')}>
                      {discountList[index].title}
                    </span>
                  </div>
                </Picker>
              </div>
              <div
                className="orderDetail-item-row"
                hidden={orderInfo.selected_benefit && orderInfo.selected_benefit.discount_type == null}
              >
                优惠抵扣：
                <span className="pull-right">{'- ¥' + discount_cut_price}</span>
              </div>
            </div>
            <div className="dialog-block-item">
              <div className="orderDetail-item-row">
                下单时间：
                <span className="pull-right">{orderInfo.add_time}</span>
              </div>
              {openBalance == true && orderInfo.status == 0 &&
                <div className="orderDetail-item-row balance">
                  储值金：
                  <Switch
                    className="pull-right"
                    checked={useBalance != 0 ? true : false}
                    type="switch"
                    onChange={this.isUseBalance}
                  ></Switch>
                  <span className="pull-right balance-num">
                    {'¥' + currentBalance}
                  </span>
                </div>
              }
              {orderInfo.status != 0 &&
                <div className="orderDetail-item-row">
                  储值抵扣：
                  <span className="pull-right">{'- ¥' + useBalance}</span>
                </div>
              }
              <div className="orderDetail-item-row">
                实付价格：
                <span className="orderDetail-pay-count pull-right">
                  {'¥' + orderInfo.totalPay}
                </span>
              </div>
            </div>
            <div className="txt-r orderDetail-btn-status">
              {orderInfo.status == 0 && (
                <React.Fragment>
                  <span
                    className="btn orderDetail-cancel-order"
                    onClick={this.cancelOrder}
                  >
                    取消订单
                  </span>
                  <span
                    className="btn btn-orange orderDetail-pay-directly"
                    onClick={this.payOrder}
                  >
                    立即支付
                  </span>
                </React.Fragment>
              )}
              {orderInfo.status == 1 && (
                <React.Fragment>
                  <span>{orderStatus[orderInfo.goods_type][1]}</span>
                  <span
                    className="btn orderDetail-verification-code"
                    onClick={this.verificationCode}
                  >
                    核销码
                  </span>
                  {orderInfo.goods_type != 3 && (
                    <span
                      className="btn orderDetail-apply-drawback"
                      onClick={this.applyDrawback}
                    >
                      申请退款
                    </span>
                  )}
                </React.Fragment>
              )}
              {orderInfo.status == 2 && (
                <React.Fragment>
                  <span
                    className="btn orderDetail-verification-code"
                    onClick={this.verificationCode}
                  >
                    核销码
                  </span>
                  {orderInfo.goods_type == 3 && (
                    <span
                      className="btn orderDetail-verification-code"
                      onClick={this.customerConfirm}
                    >
                      确认
                    </span>
                  )}
                  {orderInfo.goods_type != 3 && (
                    <span
                      className="btn orderDetail-check-logistics"
                      onClick={this.checkLogistics}
                    >
                      查看物流
                    </span>
                  )}
                  {orderInfo.goods_type != 3 && (
                    <span
                      className="btn orderDetail-apply-drawback"
                      onClick={this.applyDrawback}
                    >
                      申请退款
                    </span>
                  )}
                  {orderInfo.goods_type != 3 && (
                    <span
                      className="btn btn-orange orderDetail-sure-receipt"
                      onClick={this.sureReceipt}
                    >
                      确认收货
                    </span>
                  )}
                </React.Fragment>
              )}
              {orderInfo.status == 3 && (
                <React.Fragment>
                  {orderInfo.goods_type != 3 && (
                    <span
                      className="btn myOrder-delete"
                      onClick={this.orderDelete}
                    >
                      刪除订单
                    </span>
                  )}
                  {orderInfo.goods_type != 3 && (
                    <span
                      className="btn orderDetail-check-logistics"
                      onClick={this.checkLogistics}
                    >
                      查看物流
                    </span>
                  )}
                  {orderInfo.goods_type != 3 && (
                    <span
                      className="btn btn-orange orderDetail-make-comment"
                      onClick={this.makeComment}
                    >
                      去评价
                    </span>
                  )}
                </React.Fragment>
              )}
              {orderInfo.status == 4 && (
                <React.Fragment>
                  <span>退款审核中</span>
                </React.Fragment>
              )}
              {orderInfo.status == 5 && (
                <React.Fragment>
                  <span
                    className="btn orderDetail-receive-drawback"
                    onClick={this.receiveDrawback}
                  >
                    收到退款
                  </span>
                </React.Fragment>
              )}
              {orderInfo.status == 6 && (
                <React.Fragment>
                  <span
                    className="btn orderDetail-verification-code"
                    onClick={this.verificationCode}
                  >
                    核销码
                  </span>
                  {orderInfo.goods_type != 3 && (
                    <span
                      className="btn orderDetail-check-logistics"
                      onClick={this.checkLogistics}
                    >
                      查看物流
                    </span>
                  )}
                  <span
                    className="btn myOrder-delete"
                    onClick={this.orderDelete}
                  >
                    刪除订单
                  </span>
                </React.Fragment>
              )}
              {orderInfo.status == 7 && (
                <React.Fragment>
                  <span
                    className="btn myOrder-delete"
                    onClick={this.orderDelete}
                  >
                    刪除订单
                  </span>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/order-detail/OrderDetail.jsx